import { IconButton, makeStyles, styled, TableCell } from "@material-ui/core";
import { div, FormValue, InlineTable, Link, SelectFile, TableHeader, TableRow, Columns, Column } from "lqx-react";
import { DragNDropUpload } from "lqx-react";
import { ReadOnly } from "lqx-react";
import * as React from "react";
import { useContext, useEffect } from "react";
import DeleteIcon from '@material-ui/icons/Delete';
import { useLinked } from "@type-r/react";
import { Policy } from "../../api/policy";
import { DocumentTypes } from "../../api/reference-data";
import { DigiSelect } from "../../components/select";

export const PolicyDocuments = ({ policy }: { policy: Policy }) => {
    const readOnly = useContext(ReadOnly);
    const $file = useLinked(null);
    const $documentType = useLinked(DocumentTypes[ 0 ]);

    useEffect(() => {
        policy.transaction(() => {
            if (!$file.value) return;

            policy.uploadDocument($file.value, $documentType.value);
        });
    }, [ $file[ '_changeToken' ] ]);

    return (
        <>
            <Columns>
                <Column><Label>Select document type</Label></Column>
                <Column>
                    <DigiSelect id="id" label="name" $value={ $documentType } options={ DocumentTypes } />
                </Column>
                <Column></Column>
                <Column></Column>
            </Columns>
            <UploadContainer>
                <InlineDragNDropUpload $file={ $file } />
                <InlineUploadSelectFile $file={ $file } />
            </UploadContainer>
            <TableContainer>
                <InlineTable noBorders>
                    <TableHeader>
                        <TableCell>Document Type</TableCell>
                        <TableCell>Document Name</TableCell>
                        <TableCell>Delete</TableCell>
                    </TableHeader>
                    { policy.policyDocuments.map(document =>
                        <TableRow key={ document.cid }>
                            <TableCell>
                                <FormValue>{ document.policyDocumentType.name }</FormValue>
                            </TableCell>
                            <TableCell>
                                <Link onClick={ () => document.download() }>{ document.fileName }</Link>
                            </TableCell>

                            { !readOnly ?
                                <TableCell className="fit-width">
                                    <IconButton aria-label="Remove" onClick={ () => policy.policyDocuments.remove(document) }>
                                        <DeleteIcon />
                                    </IconButton>
                                </TableCell>
                                : null }
                        </TableRow>
                    ) }
                </InlineTable>
            </TableContainer>
        </>
    )
}

const Label = div({
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '14px',
    lineHeight: '15px',
    color: '#8695A4',
    padding: '5px'
});

const TableContainer = div({
    marginLeft: '45px',
    marginRight: '45px'
});

const UploadContainer = div({
    backgroundColor: 'white',
    padding: '20px'
});

const InlineDragNDropUpload = ({ $file }) => {
    const classes = useInlineDragNDropUploadStyles();
    return <div className={ classes.root }><DragNDropUpload $file={ $file } /></div>
}

const useInlineDragNDropUploadStyles = makeStyles({
    root: {
        '& img': {
            display: 'none'
        },
        backgroundColor: '#f3f8fb'
    }
});

const InlineUploadSelectFile = ({ $file }) => {
    const classes = useInlineUploadSelectFileStyles();
    return <span className={ classes.root }>Drag and drop your documents here or <UploadSelectFile label="select files to upload" $value={ $file } accept="*.*" /></span>
}

const useInlineUploadSelectFileStyles = makeStyles({
    root: {
        display: 'block',
        marginTop: '-40px',
        marginLeft: '20px'
    }
});

const UploadSelectFile = styled(SelectFile)({
    border: 'none',
    display: 'inline-block',
    padding: 0,
    '& .filename': {
        display: 'none'
    },
    '& .MuiSvgIcon-root': {
        display: 'none'
    },
    '& div': {
        color: '#4197d6',
        fontSize: 15
    },
    cursor: 'pointer'
});
